import { render, staticRenderFns } from "./TestCaseInformation.vue?vue&type=template&id=05f6f462&scoped=true"
import script from "./TestCaseInformation.vue?vue&type=script&lang=js"
export * from "./TestCaseInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f6f462",
  null
  
)

export default component.exports